import Main from "@/views/index.vue";

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
const otherRouter = [ {
  path:"/login",
  name:"login",
  component: () => import("@/views/user/Login.vue"),
  children:[]
},{
  path: "/",
  name: "otherRouter",
  redirect: '/transcoding/task/edit',
  component: Main,
  children: [
    {
      path: "/transcoding/task/edit",
      name: "transcodingTaskEdit",
      meta: {
        title: '任务编辑',
      },
      component: () => import("@/views/transcoding/task/Edit.vue"),
      children: []
    },
    {
      path: "/cutout/list/edit",
      name: "cutoutEdit",
      meta: {
        title: '视频抠图',
      },
      component: () => import("@/views/cutout/list/Edit.vue"),
      children: []
    },
    {
      path: "/cutout/list/edit_by_template",
      name: "cutoutEditByTemplate",
      meta: {
        title: '快速视频抠图',
      },
      component: () => import("@/views/cutout/list/EditByTemplate.vue"),
      children: []
    }
  ]
} ];

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  {
    path: "/transcoding",
    name: "transcoding",
    icon: "arrow-swap",
    title: "视频转码",
    component: Main,
    children: [
      {
        path: "/transcoding/list",
        name: "transcodingTaskList",
        icon: "ios-paper",
        meta: {
          title: "任务列表",
        },
        component: resolve =>
          import("@/views/transcoding/task/Index.vue"),
        children: []
      },
      {
        path: "/transcoding/template",
        name: "transcodingTaskTemplate",
        icon: "ios-photos-outline",
        meta: {
          title: "转码模板",
        },
        component: resolve =>
          import("@/views/transcoding/template/List.vue"),
        children: []
      }
    ]
  },
  {
    path: "/cutout",
    icon: "crop",
    name: "cutout",
    title: "视频抠图",
    component: Main,
    children: [
      {
        path: "/cutout/list",
        icon: "ios-list-outline",
        meta: {
          title: "任务列表",
        },
        name: "cutoutList",
        component: resolve =>
          import("@/views/cutout/list/Index.vue"),
        children: []
      }
    ]
  }
];

export const routers = [ ...appRouter, ...otherRouter ];
